<template>
    <div class="merged-page">
        <AppBreadCrumb :paths="[{ title: $t('message.departments') }]" :select="true">
            <a-input-search
                v-model="searchText"
                :placeholder="$t('message.startFilter')"
                class="search-input"
                @search="onSearch"
            />
            <a-button
                class="actionButtonBreadcrumb"
                @click="showModalWithoutEdit"
                v-if="checkPermission(PERMISSION_TYPES['topic.create'].tr.name)"
            >
                <md-icon>add</md-icon>
                {{ $t("message.newDepartment") }}
            </a-button>
        </AppBreadCrumb>
        <div style="background-color: #ffffff" class="d-flex w-100">
            <div class="side-menubar-wrapper" style="width: 15%">
                <UsersMenu />
            </div>
            <div id="subjects">
                <b-container fluid>
                    <a-table
                        :key="'vtable-' + renderCount"
                        :columns="cols()"
                        :dataSource="getFilteredRows()"
                        :loading="isBusy"
                        :locale="{
                            emptyText: $t('message.noSubjectFound'),
                        }"
                        :pagination="false"
                        class="custom-table2"
                        rowKey="_id"
                        @change="tableChange"
                    >
                        <div :key="'statusSlot' + $i18n.locale" :slot="'statusSlot'" slot-scope="data, item">
                            {{ item.isActive ? $t("message.active") : $t("message.passive") }}
                        </div>
                        <!--                <div :key='"actionsSlot"+$i18n.locale' :slot='"actionsSlot"' slot-scope="data, item">-->
                        <!--                    <div class="d-flex w-100 justify-content-start">-->
                        <!--                        <a-button-->
                        <!--                                v-tippy="{followCursor : true,placement : 'bottom-end',theme : isDarkMode? 'light-border':'google'}"-->
                        <!--                                :content="$t('message.editThisItem')" class="tableActionButton" shape="circle"-->
                        <!--                                type="primary"-->
                        <!--                                @click="edit(item._id)"-->
                        <!--                        >-->
                        <!--                            <font-awesome-icon icon="pencil-alt" size="sm"/>-->
                        <!--                        </a-button>-->
                        <!--                        <a-button-->
                        <!--                                v-tippy="{followCursor : true,placement : 'bottom-end',theme : isDarkMode? 'light-border':'google'}"-->
                        <!--                                :content="$t('message.removeThisItem')" class="tableActionButton red" shape="circle"-->
                        <!--                                type="danger"-->
                        <!--                                @click="remove(item._id)"-->
                        <!--                        >-->
                        <!--                            <font-awesome-icon icon="times" size="sm"/>-->
                        <!--                        </a-button>-->
                        <!--                    </div>-->
                        <!--                </div>-->
                        <div :key="'actionsSlot' + $i18n.locale" :slot="'actionsSlot'" slot-scope="data, item">
                            <div class="d-flex w-100 justify-content-start">
                                <a-button class="actionButton d-flex align-items-center" @click="edit(item._id)">
                                    <span style="margin-right: 16px; display: block">{{ $t("message.edit") }}</span>
                                    <ActionEdit />
                                </a-button>
                                <a-button
                                    class="actionButton d-flex align-items-center"
                                    @click="remove(item._id)"
                                    v-if="checkPermission(PERMISSION_TYPES['topic.delete'].tr.name)"
                                >
                                    <span style="margin-right: 16px; display: block">{{
                                        $t("message.deleteField")
                                    }}</span>
                                    <ActionDelete />
                                </a-button>
                            </div>
                        </div>
                    </a-table>
                    <div class="mt-3 d-flex justify-content-end">
                        <Pagination :page-change="pageChange" :page-sizes="pageSizes" :total="subjects.total" />
                    </div>
                </b-container>
                <div class="fab d-flex justify-content-center align-items-center" @click="showModalWithoutEdit">
                    <md-icon class="">add</md-icon>
                </div>
                <Modal2
                    v-if="isModalShow"
                    id="subject-form"
                    :title="editMode ? $t('message.updateDepartmentForm') : $t('message.newDepartmentForm')"
                    @cancel="hideModal"
                    :show-footer="false"
                >
                    <div id="modal-inner">
                        <a-alert
                            v-if="$validator.errors.items.length && submitClicked"
                            :key="`alertContainer-${$i18n.locale}`"
                            :message="$t('message.error')"
                            class="mb-2"
                            showIcon
                            type="error"
                        >
                            <div slot="description">
                                <div v-for="err of $validator.errors.items">
                                    <span>
                                        {{ err.msg }}
                                    </span>
                                </div>
                            </div>
                        </a-alert>
                        <b-form class="d-flex flex-column justify-content-center" @submit.prevent="duplicateControl">
                            <b-row>
                                <b-col md="12">
                                    <b-row>
                                        <b-col md="12">
                                            <MultiContent v-model="subjectInitialObject" ref="MultiContent" />
                                        </b-col>
                                        <b-col class="mt-3" md="12">
                                            <b-form-group label="Durum">
                                                <b-form-radio-group v-model="subject.isActive" name="status" required>
                                                    <b-form-radio :value="true"
                                                        >{{ $t("message.active") }}
                                                    </b-form-radio>
                                                    <b-form-radio :value="false"
                                                        >{{ $t("message.passive") }}
                                                    </b-form-radio>
                                                </b-form-radio-group>
                                            </b-form-group>
                                        </b-col>
                                        <b-col md="12">
                                            <b-button
                                                :disabled="loading"
                                                type="submit"
                                                variant="primary"
                                                v-if="checkPermission(PERMISSION_TYPES['topic.update'].tr.name)"
                                            >
                                                <template v-if="!loading">
                                                    <span v-if="!editMode">
                                                        {{ $t("message.save") }}
                                                    </span>
                                                    <span v-else>
                                                        {{ $t("message.update") }}
                                                    </span>
                                                </template>
                                                <template v-else>
                                                    <font-awesome-icon icon="spinner" spin />
                                                </template>
                                            </b-button>
                                            <b-button @click="hideModal">
                                                <template>
                                                    {{ $t("message.cancel") }}
                                                </template>
                                            </b-button>
                                        </b-col>
                                    </b-row>
                                </b-col>
                            </b-row>
                        </b-form>
                    </div>
                </Modal2>
            </div>
        </div>
        <ChatBar v-if="!isAdmin" :visible="false" />
    </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faPencilAlt, faPlusCircle, faSpinner, faTimes } from "@fortawesome/free-solid-svg-icons";
import { log2 } from "../../utils/log2";
import AppBreadCrumb from "../../components/common/AppBreadCrumb";
import * as _ from "lodash";
import ChatBar from "../../components/ChatBar";
import UsersMenu from "./UsersMenu";
import { sendSocketMessage } from "../../utils/socketStream";
import { tableSorter } from "../../utils/utils";
import ActionEdit from "../../components/svg/ActionEdit";
import ActionDelete from "../../components/svg/ActionDelete";
import Pagination from "../../components/Pagination";
import { toArray2, toObject2 } from "../../utils/languageContent";
import MultiContent from "../../components/MultiContent";
import Modal2 from "../../components/common/Modal2.vue";
import { PERMISSION_TYPES } from "../../language/permissionTypes";

library.add(faPencilAlt, faTimes, faPlusCircle, faSpinner);
const log = log2("Subjects");
const subjectInitialObject = {
    _id: null,
    languageContent: {
        tr: {
            name: "",
            description: "",
        },
        en: {
            name: "",
            description: "",
        },
        ru: {
            name: "",
            description: "",
        },
        fr: {
            name: "",
            description: "",
        },
        es: {
            name: "",
            description: "",
        },
        ar: {
            name: "",
            description: "",
        },
        it: {
            name: "",
            description: "",
        },
    },
    isActive: true,
};
export default {
    name: "Subjects",
    components: {
        AppBreadCrumb,
        ChatBar,
        MultiContent,
        ActionEdit,
        ActionDelete,
        Pagination,
        UsersMenu,
        Modal2,
    },
    data() {
        return {
            editID: null,
            isBusy: true,
            loading: false,
            editMode: false,
            subject: _.cloneDeep(subjectInitialObject),
            submitClicked: false,
            pageSizes: ["10", "25", "50", "100"],
            searchText: undefined,
            cols: () => [
                {
                    dataIndex: "_id",
                    title: "#ID",
                },
                {
                    dataIndex: "languageContent." + this.$i18n.locale + ".name",
                    title: this.$t("message.title"),
                    ...tableSorter("languageContent." + this.$i18n.locale + ".name", "string", this.currentSort),
                },
                {
                    dataIndex: "languageContent." + this.$i18n.locale + ".description",
                    title: this.$t("message.description"),
                },
                {
                    dataIndex: "enable",
                    title: this.$t("message.status"),
                    scopedSlots: { customRender: "statusSlot" },
                    ...tableSorter("enable", "string", this.currentSort),
                },
                {
                    title: this.$t("message.transactions"),
                    scopedSlots: { customRender: "actionsSlot" },
                    width: "10%",
                },
            ],
            perPage: 100,
            page: 1,
            currentSort: {
                columnKey: "enable",
                order: "ascend",
            },
            renderCount: 0,
            subjectTitle: "",
            isModalShow: false,
            queryAction: this.$route.query.action,
        };
    },
    computed: {
        PERMISSION_TYPES() {
            return PERMISSION_TYPES;
        },
        ...mapState({
            subjects: (state) => state.subject.subjects,
            languages: (state) => state.language.languages,
            site: (state) => state.site.site,
            isAdmin: (state) => state.auth.adminUser != null,
            defaultLang: (state) => state.setting.settings.language.clientDefault,
            systemLanguages: (state) => state.setting.settings.systemLanguages,
        }),
        ...mapGetters({
            undeleted: "subject/getUndeleted",
            isDarkMode: "user/isDarkMode",
            checkPermission: "auth/checkPermission",
        }),
        subjectInitialObject: {
            get() {
                if (!this.systemLanguages) {
                    return [];
                }
                return [
                    {
                        type: "input",
                        field: "name",
                        label: this.$t("message.messageTitle"),
                        placeholder: this.$t("message.messageTitle"),
                        data: this.systemLanguages.reduce((acc, lang) => {
                            acc[lang] = _.get(this.subject.languageContent, `[${lang}].name`, "");
                            return acc;
                        }, {}),
                        validation: "required",
                    },
                    {
                        type: "rich",
                        field: "description",
                        label: this.$t("message.message"),
                        placeholder: this.$t("message.message"),
                        data: this.systemLanguages.reduce((acc, lang) => {
                            acc[lang] = _.get(this.subject.languageContent, `[${lang}].description`, "");
                            return acc;
                        }, {}),
                        validation: "required",
                    },
                ];
            },
            set(v) {
                this.subject.languageContent = this.systemLanguages.reduce((acc, lang) => {
                    acc[lang] = {};
                    for (const _v of v) acc[lang][_v.field] = _v.data[lang];
                    return acc;
                }, {});
            },
        },

        subjectInitialObjectTitle: {
            get() {
                return toArray2(this.subject, "languageContent", "name").languageContent;
            },
            set(value) {
                this.subject.languageContent = toObject2(value, "name");
            },
        },
        subjectInitialObjectContent: {
            get() {
                return toArray2(this.subject, "languageContent", "description").languageContent;
            },
            set(value) {
                this.subject.languageContent = toObject2(value, "description");
                this.addNewSubjectTitle();
            },
        },
    },
    methods: {
        ...mapActions({
            getSubjects: "subject/getSubjects",
            getSubject: "subject/getSubject",
            createSubject: "subject/createSubject",
            updateSubject: "subject/updateSubject",
            deleteSubject: "subject/deleteSubject",
        }),
        showModal() {
            this.isModalShow = true;
        },
        hideModal() {
            this.isModalShow = false;
            this.reset();
        },
        showModalWithoutEdit() {
            this.editMode = false;
            this.showModal();
        },

        titleChangeHandler(value) {
            this.subjectTitle = value;
            this.addNewSubjectTitle();
        },

        addNewSubjectTitle() {
            Object.keys(this.subjectTitle).forEach((key) => {
                this.subject.languageContent[key].name = this.subjectTitle[key];
            });
        },

        onDeleteLanguage(data) {
            this.subject.languageContent = toObject2(data.content, "description");
            this.addNewSubjectTitle();
        },
        tableChange(pagination, filters, sorter) {
            log("tableChange", { pagination, filters, sorter });
            this.perPage = pagination.pageSize;
            log("tableChange", { pagination, filters, sorter });
            const newSort = {
                columnKey: sorter.columnKey,
                order: sorter.order,
            };
            const oldSort = this.currentSort;
            log("show me current Sort", {
                currentSort: this.currentSort,
                newSort,
            });
            if (!_.isEqual(newSort, oldSort)) {
                this.currentSort = newSort;
                this.renderCount += 1;
                this.$forceUpdate();
            }
        },
        getFilteredRows() {
            const items = this.searchText
                ? this.undeleted.filter((x) =>
                      x.languageContent[this.$i18n.locale].name
                          .toLocaleLowerCase("tr-TR")
                          .includes(this.searchText.toLocaleLowerCase("tr-TR"))
                  )
                : this.undeleted;
            return items;
        },
        onSearch(value) {
            log("onSearch", value);
            this.searchText = value;
        },
        pageChange(page, pageSize) {
            log("pageChange", { page, pageSize });
            this.page = page;
            this.perPage = pageSize;
        },
        onShowSizeChange(current, pageSize) {
            log("onShowSizeChange", current, pageSize);
            this.page = current;
            this.perPage = pageSize;

        },
        get() {
            this.isBusy = true;
            this.getSubjects({ perPage: this.perPage, page: this.page }).then(() => {
                this.isBusy = false;
                if (this.queryAction == "create") this.isModalShow = true;
            });
        },
        edit(id) {
            this.getSubject(id).then((response) => {
                this.subject = _.cloneDeep(response);
                this.editMode = true;
                this.editID = id;
                /*this.$bvModal.show("subject-form");*/
                this.showModal();
            });
        },
        publishNewSubjects() {
            const socketMessageId = "user publish-subjects";
            sendSocketMessage(socketMessageId, {
                siteId: this.site._id,
            });
        },
        remove(id) {
            this.$dialog
                .confirm(this.$t("message.deleteDepartmentQuestion"), {
                    okText: this.$t("message.continue"),
                    cancelText: this.$t("message.cancel"),
                })
                .then(() => {
                    this.deleteSubject(id)
                        .then((x) => {
                            this.$toasted.show(this.$t("message.departmentDeleted"), {
                                duration: 3000,
                                position: "bottom-center",
                            });
                            const socketMessageId = this.isAdmin ? "admin subject-deleted" : "user subject-deleted";
                            sendSocketMessage(socketMessageId, {
                                subjectId: id,
                                siteId: this.site._id,
                            });
                            this.publishNewSubjects();
                        })
                        .catch((err) => {
                            log.error(err.response, err.message);
                            const errMsg =
                                err.response && err.response.data && err.response.data.localizedMessages
                                    ? err.response.data.localizedMessages[this.$i18n.locale]
                                    : err.message;
                            this.$toasted.error(errMsg, {
                                duration: 3000,
                                position: "bottom-center",
                            });
                        });
                });
        },
        reset() {
            log.debug("reset called");
            this.subject = _.cloneDeep(subjectInitialObject);
            this.submitClicked = false;
        },
        duplicateControl() {
            const isThereSameSubject = this.subjects.data.find(
                (x) =>
                    x.languageContent[this.$i18n.locale].name.toLowerCase() ===
                    this.subject.languageContent[this.$i18n.locale].name.toLowerCase()
            );
            const duplicateId = isThereSameSubject ? isThereSameSubject._id : null;
            const isThisSameSubject = duplicateId === this.editID;
            if (!isThisSameSubject && duplicateId !== null) {
                this.$toasted.error(this.$t("message.sameDepartment"), {
                    duration: 3000,
                    position: "bottom-center",
                });
                return;
            } else {
                this.handleSave();
            }
        },
        handleSave() {
            this.submitClicked = true;
            this.$validator.validateAll().then((response) => {
                if (response) {
                    this.loading = true;
                    Object.keys(this.subject.languageContent).forEach((key) => {
                        if (!this.subject.languageContent[key].name) {
                            this.subject.languageContent[key].description =
                                this.subject.languageContent[this.defaultLang].description;
                            this.subject.languageContent[key].name =
                                this.subject.languageContent[this.defaultLang].name;
                        }
                    });
                    const result = this.subject._id
                        ? this.updateSubject(this.subject)
                        : this.createSubject(this.subject);

                    result
                        .then(() => {
                            /*this.$bvModal.hide("subject-form");*/
                            this.hideModal();
                            this.$toasted.show(this.$t("message.departmentSaved"), {
                                duration: 3000,
                                position: "bottom-center",
                            });
                            this.get();
                            this.reset();
                            this.publishNewSubjects();
                            sendSocketMessage("team refresh-chats", {
                                siteId: this.site._id,
                            });

                        })
                        .finally(() => {
                            this.loading = false;
                            this.submitClicked = false;
                        });
                } else {
                    log("validation error", response, this.$validator);
                    this.loading = false;
                }
            });
        },
    },
    mounted() {
        this.get();
    },
    updated() {
        if (this.$validator.locale !== this.$i18n.locale) this.$validator.localize(this.$i18n.locale);
    },
    watch: {
        page(newValue) {
            if (newValue) {
                this.get();
            }
        },
        perPage(newValue, oldValue) {
            if (newValue) {
                this.get();
            }
        },
    },
};
</script>

<style lang="scss">
.ant-table-tbody > tr > td:nth-child(3){
  overflow-wrap: anywhere !important;
}
.new-theme {
    #subjects {
        min-height: 90vh;
        width: 85%;
        background: #eef0f8;

        .actionButton {
            border: none;
            box-shadow: none;
        }
    }
}

.fab {
    width: 50px;
    height: 50px;
    border-radius: 25px;
    background-color: white;
    position: absolute;
    bottom: 20px;
    left: 100px;
    z-index: 9999;
    transition: all 0.3s;
    box-shadow: 0 0 0 0 rgba(100, 100, 100, 1);
    transform: scale(1);
    animation: pulse 3s infinite;
    cursor: pointer;
}

@keyframes pulse {
    0% {
        transform: scale(0.95);
        box-shadow: 0 0 0 0 rgba(100, 100, 100, 0.5);
    }

    70% {
        transform: scale(1);
        box-shadow: 0 0 0 10px #00000000;
    }

    100% {
        transform: scale(0.95);
        box-shadow: 0 0 0 0 #00000000;
    }
}

#subject-form {
    #modal-inner {
        overflow-y: scroll;
        overflow-x: hidden;
        max-height: 70vh;
        padding: 0 20px;
    }

    .ant-modal-wrap {
        max-height: 100vh;
    }

    .ant-modal {
        width: 700px !important;
        padding-bottom: 0;
        top: 40px;
    }
}
</style>
